<template>
  <div class="dof-card-item">
    <div class="dof-card-item-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import DiabloMixin from '../../mixins/diablo'
export default {
  mixins: [DiabloMixin]
}
</script>

<style scoped>
.dof-card-item {
  padding-left: 32px;
  padding-right: 32px;
}

.dof-card-item-content {
  border-top-style: solid;
  border-top-width: 1px;
  border-top-color: #f6f7f9;
}

@media screen and (weex-theme: colmo) {
  .dof-card-item-content {
    border-top-width: 0px;
  }
}
@media screen and (weex-theme: diablo) {
  .dof-card-item-content {
    border-top-color: #303538;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?f173f23a